<template>
  <div class="m-footer">
    <div>科技铸造首纳 安全守护家人</div>
    <div class="m-footer-codes">
      <div>
        <img src="./assets/qr-wechat.jpg" alt="微信公众号">
        <span>微信公众号</span>
      </div>
      <div>
        <img src="./assets/qr-video.jpg" alt="视频号">
        <span>视频号</span>
      </div>
    </div>
    <div class="m-footer-bot">
      <div>Copyright ©2010 - 2022 苏州今蓝纳米科技有限公司</div>
      <div>苏ICP备16033581号-1 | 公安备案 苏公网安备 32050002002855号 |</div>
      <div>主营：汽车太阳膜 汽车车衣 汽车玻璃膜 隐形隔热膜 车窗膜 漆面保护膜 汽车贴膜</div>
    </div>
  </div>
</template>
<style lang="scss">
/* 响应式调整：屏幕较窄时，项目垂直排列 */
@media (max-width: 768px) {
  .m-footer{
    padding-top: 20px;
    background: #292A2A;
    color: #FFFFFF;
    font-size: 14px;
    text-align: center;

   .m-footer-codes {
     display: flex;
     justify-content: center;
     margin-top: 20px;
     margin-bottom: 20px;

     & > div {
       width: 100px;
       img {
         display: block;
         margin-bottom: 10px;
       }

       &:first-child {
         margin-right: 30px;
       }
     }
   }

    .m-footer-bot {
      height: 53px;
      font-size: 9px;
      background: #3F3F3F;
      padding-top: 5px;
    }
  }
}
</style>